
export interface ReceiptIssueResponse {
  message?: string;
  receiptId?: string;
  receiptUrl?: string;
  success: boolean;
}
